import { FC } from 'react';
import { List } from './components/List';

export const AdminInvoiceReports: FC = () => {
  return <List />;
};
